<template lang="pug">
div
  v-card(flat)
    v-card-title Sponsor Information
    keep-alive
      validation-observer(ref="o03" v-slot="{ invalid }" :persist="true" vid="o03")
        v-container
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") Is the sponsor a non-profit?
            v-col(:lg="9" :md="9" :sm="12" :cols="12")          
              v-radio-group(v-model="SEA_Nonprofit")
                v-radio(
                  v-for="option in nonprofit",
                  :key="option"
                  :label="option"
                  :value="option"
                      :disabled="disabled"
                )
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-text-field.d-none(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_Nonprofit",
                  counter,
                  maxlength="100",
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") Sponsor First Name
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_SponsorNameFirst"
                        :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") Sponsor Last Name
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_SponsorNameLast"
                        :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") Sponsor's Email
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="required|email", v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_SponsorEmail"
                        :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") Sponsor's Contact Phone
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(
                :rules="{required, regex: /[0-9]{3}-[0-9]{3}-[0-9]{4}/ }",
                v-slot="{ errors }"
                immediate
              )
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_SponsorContactPhone"
                        :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") Address
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_SponsorAddress1"
                        :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") Address Line 2
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_SponsorAddress2"
                      :disabled="disabled"
              )
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") City
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_SponsorAddressCity"
                        :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style={width: '200px'}) State
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-select.pb-3.pl-3(
                  :items="states"
                  item-text="name"
                  item-value="abbreviation"
                  solo
                  v-model="SEA_SponsorAddressState"
                  attach
                  :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
          v-row
            v-col(:lg="3" :md="3" :sm="12" :cols="12")
              p.body-1(:style="{ width: '200px' }") ZIP Code
            v-col(:lg="9" :md="9" :sm="12" :cols="12")
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(
                  outlined,
                  hide-details,
                  dense,
                  v-model="SEA_SponsorAddressZIP"
                        :disabled="disabled"
                )
                p.pb-0.red--text.text--lighten-1.pl-4 {{ errors[0] }}
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      nonprofit: (state) => state.nonprofit,
      states: (state) => state.states,
      data: (state) => state.data,
    }),
    ...mapFields([
      "data.SEA_Nonprofit",
      "data.SEA_SponsorNameFirst",
      "data.SEA_SponsorNameLast",
      "data.SEA_SponsorEmail",
      "data.SEA_SponsorContactPhone",
      "data.SEA_SponsorAddress1",
      "data.SEA_SponsorAddress2",
      "data.SEA_SponsorAddressCity",
      "data.SEA_SponsorAddressState",
      "data.SEA_SponsorAddressZIP",
      "data.disabled",
    ]),
  },
  data: () => ({
    required: 'required',
  }),
  methods: {
    //
  },
};
</script>